import axios from 'axios';

const ePlatApi = axios.create({
    baseURL: 'https://developers.eplat.com/api'
    // baseURL: 'https://localhost:44308/api'
});

//Registra un lead en el webhook indicado en el objecto formData
export const registerLead = async (formData = {}) => {
    return new Promise((resolve, reject) => {
        ePlatApi.post(`/webhooks/incoming/genericjson/newlead?code=80f32f6123104d09a72c000047564e51`, formData)
            .then(({ data }) => resolve(data))
            .catch(reject);
    });
}
